export const textContent = {
  consigne: {
    mainScreen: 'Le professeur vous a eu :)',
    player: 'Vous avez échoué'
  }
}
